import { Injectable } from '@angular/core';
import { BaseItemModelService } from './base-item.model';
import { TemplateControlType } from './types/template-control-type';
import { FiDocumentTemplateItemViewSiteMapComponent } from '../document-template/document-template-item-view/document-template-item-view-site-map.component';
import { FiDocumentTemplateItemOptionsSiteMapComponent } from '../document-template/document-template-item-options/document-template-item-options-site-map/document-template-item-options-site-map.component';
import { TemplatePlaceHolderControlModel } from '@fi-app/template/template-placeholder-control.model';

@Injectable()
export class SiteMapItemModelService {
    private siteMapItem: BaseItemModelService;
    model: TemplatePlaceHolderControlModel;
    constructor(baseItemModel: BaseItemModelService) {
        this.siteMapItem = Object.create(baseItemModel);
        this.siteMapItem.init(
            'siteMap',
            TemplateControlType.SiteMap,
            FiDocumentTemplateItemViewSiteMapComponent,
            FiDocumentTemplateItemOptionsSiteMapComponent,
            'sitemap.object_name',
            'fa fa-list',
            function (instance) {
                instance.model.Contents.forEach(function (content) {
                    content.Value.Col1 = defaultColSettings();
                    content.Value.Col2 = defaultColSettings();
                });
            },
        );

        Object.assign(this, this.siteMapItem);

        function defaultColSettings() {
            return {
                displayTitle: true,
                displayNumbering: true,
                displayFiles: true,
            };
        }
    }

    IsEmpty(ContentLanguageId: number) {
        var self = this;
        var result = true;
        self.model.Contents.forEach(function (content) {
            if (content.ContentLanguageId == ContentLanguageId) {
                if (content.Value.Col1 && content.Value.Col1.IsEmpty === false) {
                    result = false;
                }
                if (content.Value.Col2 && content.Value.Col2.IsEmpty === false) {
                    result = false;
                }
            }
        });

        return result;
    }

    create() {
        return this.siteMapItem.create.call(this.siteMapItem);
    }
}
